import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import {
  LearningAudioIcon,
  LearningContentIcon,
  LearningCoursesIcon,
  LearningInfoIcon,
  LearningPresentIcon,
  LearningVideoIcon,
} from "../../shared/learningIocn";
import {
  EnvironmentIcon,
  FrameWorkIcon,
  MeditationIcon,
  MovementIcon,
  NutritionIcon,
  PracticeIcon1,
  PracticeIcon2,
  PracticeIcon3,
  PracticeIcon4,
  SelfCompassionIcon,
  SleepIcon,
  SocialConnectionIcon,
} from "../../shared/icon";
import videoImage from "../../assets/learning/video.webp";

export const cardData = [
  {
    id: 1,
    title: "Unlock Better Sleep by Understanding Sleep Cycles",
    duration: "12 mins",
    tag: "Sleep",
    type: "video",
    action: "Play",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
    from: "vasana",
  },
  {
    id: 2,
    title: "The Power of Strategic Naps for Peak Performance",
    duration: "3 mins",
    tag: "Mental Fitness",
    type: "article",
    action: "Read",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
    from: "vasana",
  },
  {
    id: 3,
    title: "Drifting Away into Sleep",
    duration: "12 mins",
    tag: "Sleep",
    type: "audio",
    action: "Play",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
    from: "frontline",
  },
  {
    id: 4,
    title: "Managing Sleep When You Work Odd Hours",
    duration: "12 mins",
    tag: "Sleep",
    type: "course",
    action: "Read",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
    from: "frontline",
  },
  {
    id: 5,
    title: "The Power of Strategic Naps for Peak Performance",
    duration: "3 mins",
    tag: "Mental Fitness",
    type: "presentation",
    action: "Read",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
    from: "vasana",
  },
  {
    id: 6,
    title: "Managing Sleep When You Work Odd Hours",
    duration: "12 mins",
    tag: "Sleep",
    type: "infographics",
    action: "Read",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
    from: "vasana",
  },
  {
    id: 7,
    title: "Boost Your Focus with Power Naps",
    duration: "8 mins",
    tag: "Productivity",
    type: "video",
    action: "Watch",
    desc: "Learn how short naps can improve memory, cognitive function, and alertness during long work hours.",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    from: "vasana",
  },
  {
    id: 8,
    title: "The Science of Better Sleep",
    duration: "15 mins",
    tag: "Health",
    type: "article",
    action: "Watch",
    desc: "Explore the science behind sleep cycles and how to optimize your rest.",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    from: "vasana",
  },
  {
    id: 9,
    title: "Sleep Tips for Night Shift Workers",
    duration: "10 mins",
    tag: "Sleep",
    type: "infographics",
    action: "Watch",
    desc: "Practical sleep hygiene tips to help you rest better even when working late hours.",
    video: "https://www.w3schools.com/html/mov_bbb.mp4",
    from: "vasana",
  },
];

export const getContentTypeDetails = (type, color = "currentColor") => {
  switch (type) {
    case "video":
      return {
        icon: <LearningVideoIcon color="currentColor" />,
        label: "Play Now",
        content: "Video",
        samllIcon: (
          <PlayArrowOutlinedIcon
            fontSize="large"
            style={{ color: "#3A3A40" }}
          />
        ),
      };
    case "audio":
      return {
        icon: <LearningAudioIcon color={color} />,
        label: "Listen Now",
        content: "Audio",
        samllIcon: <LearningAudioIcon color="#3A3A40" />,
      };
    case "article":
      return {
        icon: <LearningContentIcon color={color} />,
        label: "Read Now",
        content: "Article",
        samllIcon: <LearningContentIcon color="#3A3A40" />,
      };
    case "course":
      return {
        icon: <LearningCoursesIcon color={color} />,
        label: "Learn Now",
        content: "Course",
        samllIcon: <LearningCoursesIcon color="#3A3A40" />,
      };
    case "presentation":
      return {
        icon: <LearningPresentIcon color={color} />,
        label: "View Now",
        content: "Presentation",
        samllIcon: <LearningPresentIcon color="#3A3A40" />,
      };
    case "infographic":
      return {
        icon: <LearningInfoIcon color={color} />,
        label: "View Now",
        content: "Infographic",
        samllIcon: <LearningInfoIcon color="#3A3A40" />,
      };
    default:
      return {
        icon: <LearningVideoIcon color={color} />,
        label: "Play Now",
        content: "Video",
        samllIcon: <LearningVideoIcon color="#3A3A40" />,
      };
  }
};

export const categories = [
  {
    icon: <FrameWorkIcon />,
  },
  {
    icon: <SleepIcon />,
  },
  {
    icon: <NutritionIcon />,
  },
  {
    icon: <MeditationIcon />,
  },
  {
    icon: <SelfCompassionIcon />,
  },
  {
    icon: <SocialConnectionIcon />,
  },
  {
    icon: <EnvironmentIcon />,
  },
  {
    icon: <MovementIcon />,
  },
];

export const practicesData = [
  {
    icon: <PracticeIcon1 />,
    title: "Enjoy 5 Deep Breaths",
    bgColor: "#FFF7EC",
    borderColor: "#FFB142",
  },
  {
    icon: <PracticeIcon2 />,
    title: "Burn the Negative",
    bgColor: "#E3F1F9",
    borderColor: "#1780C6",
  },
  {
    icon: <PracticeIcon3 />,
    title: "Visualize Grateful Moments",
    bgColor: "#FFF7EC",
    borderColor: "#F07610",
  },
  {
    icon: <PracticeIcon4 />,
    title: "Shake it Off",
    bgColor: "#FEF2F2",
    borderColor: "#F54346",
  },
  {
    icon: <PracticeIcon2 />,
    title: "Burn the Negative",
    bgColor: "#E3F1F9",
    borderColor: "#1780C6",
  },
  {
    icon: <PracticeIcon3 />,
    title: "Visualize Grateful Moments",
    bgColor: "#FFF7EC",
    borderColor: "#F07610",
  },
  {
    icon: <PracticeIcon4 />,
    title: "Shake it Off",
    bgColor: "#E3F1F9",
    borderColor: "#1780C6",
  },
  {
    icon: <PracticeIcon2 />,
    title: "Burn the Negative",
    bgColor: "#FFF7EC",
    borderColor: "#FFB142",
  },
];

export const commingUpNextData = [
  {
    id: 1,
    title: "Unlock Better Sleep by Understanding Sleep Cycles",
    duration: "12 mins",
    tag: "Sleep",
    type: "Video",
    action: "Play",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
  },
  {
    id: 2,
    title: "The Power of Strategic Naps for Peak Performance",
    duration: "3 mins",
    tag: "Mental Fitness",
    type: "Article",
    action: "Read",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
  },
  {
    id: 3,
    title: "Drifting Away into Sleep",
    duration: "12 mins",
    tag: "Sleep",
    type: "Audio",
    action: "Play",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
  },
  {
    id: 4,
    title: "Managing Sleep When You Work Odd Hours",
    duration: "12 mins",
    tag: "Sleep",
    type: "Coures",
    action: "Read",
    desc: "Discover how short, well-timed naps can boost energy, focus, and productivity.",
  },
];

export const downloadData = [
  {
    image: videoImage,
    title: "Vasana Breakdown Recovery Mini Poster",
  },
  {
    image: videoImage,
    title: "Vasana Competing Outside The Box Mini Poster",
  },
  {
    image: videoImage,
    title: "Vasana Domains of Leadership Mini Poster",
  },
  {
    image: videoImage,
    title: "Vasana IncomeEquity Mini Poster",
  },
  {
    image: videoImage,
    title: "Vasana Breakdown Recovery Mini Poster",
  },
];
